import React from 'react'

const EventList = () => {
  return (
    <div></div>
  )
}

export default EventList